/**
 * EditingTools Component  
 * Split, Join, and Markers toolbar buttons
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Scissors, Merge, Flag } from 'lucide-react';
import { toast } from 'sonner';

export const EditingTools = ({
  clipEditMode,
  setClipEditMode,
  selectedClipsForJoin,
  setSelectedClipsForJoin,
  showMarkersPanel,
  setShowMarkersPanel,
  markersCount = 0,
  onJoinClips,
}) => {
  const handleJoinExecute = () => {
    if (onJoinClips) {
      onJoinClips();
    }
    setSelectedClipsForJoin([]);
    setClipEditMode(null);
  };

  return (
    <>
      {/* Split Tool */}
      <Button
        variant={clipEditMode === 'split' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => {
          setClipEditMode(clipEditMode === 'split' ? null : 'split');
          setSelectedClipsForJoin([]);
          if (clipEditMode !== 'split') toast.info('Split mode: Click on a clip to split at playhead');
        }}
        className={`relative p-2 ${clipEditMode === 'split' ? 'bg-rose-500/20 text-rose-400 border border-rose-500/50' : 'text-zinc-400 hover:text-white'}`}
        data-testid="split-tool"
        title="Split clips at playhead"
      >
        <Scissors className="w-5 h-5" />
      </Button>
      
      {/* Markers Panel Toggle */}
      <Button
        variant={showMarkersPanel ? 'default' : 'ghost'}
        size="sm"
        onClick={() => setShowMarkersPanel(!showMarkersPanel)}
        className={`relative p-2 ${showMarkersPanel ? 'bg-orange-500/20 text-orange-400 border border-orange-500/50' : 'text-zinc-400 hover:text-white'}`}
        data-testid="markers-toggle"
        title="Markers & Regions"
      >
        <Flag className="w-5 h-5" />
        {markersCount > 0 && (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-orange-500 rounded-full text-[10px] font-bold flex items-center justify-center text-white">
            {markersCount}
          </span>
        )}
      </Button>
      
      {/* Join Tool */}
      <Button
        variant={clipEditMode === 'join' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => {
          setClipEditMode(clipEditMode === 'join' ? null : 'join');
          setSelectedClipsForJoin([]);
          if (clipEditMode !== 'join') toast.info('Join mode: Click clips to select, then click Join');
        }}
        className={`relative p-2 ${clipEditMode === 'join' ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/50' : 'text-zinc-400 hover:text-white'}`}
        data-testid="join-tool"
        title="Join/Merge clips"
      >
        <Merge className="w-5 h-5" />
        {selectedClipsForJoin.length > 0 && (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full text-[10px] font-bold flex items-center justify-center text-white">
            {selectedClipsForJoin.length}
          </span>
        )}
      </Button>
      
      {/* Join Execute Button - only visible when clips selected */}
      {clipEditMode === 'join' && selectedClipsForJoin.length >= 2 && (
        <Button
          variant="default"
          size="sm"
          onClick={handleJoinExecute}
          className="bg-emerald-500 hover:bg-emerald-600 text-white px-3"
          data-testid="join-execute"
        >
          Join {selectedClipsForJoin.length} clips
        </Button>
      )}
    </>
  );
};

export default EditingTools;
